export default "__VITE_ASSET__C6K9EhE7__"